export const DAY_OF_THE_WEEK_I18N = [
	{ default: "日", en: "Su" },
	{ default: "月", en: "Mo" },
	{ default: "火", en: "Tu" },
	{ default: "水", en: "We" },
	{ default: "木", en: "Th" },
	{ default: "金", en: "Fr" },
	{ default: "土", en: "Sa" },
] as const;
